import React from "react";
import { useTranslation } from "react-i18next";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import html2canvas from "html2canvas";
import millify from "millify";

//import exporting from "highcharts/modules/exporting";
//exporting(Highcharts);

const CroissancesChartesYoutube = (props) => {
  props = props.state;
  const myData = props.cmpData.data;

  ///////////graph2////
  const { t } = useTranslation();
  let options2 = {
    chart: {
      type: "column",
    },
    title: {
      text: t("Benchmark.Average_Interactions_per_Post"),
      align: "left",
      margin: 50,
    },
    subtitle: {
      text: t("Benchmark.Average_Interactions_per_Post_desc"),
      align: "left",
      margin: 10,
    },
    subtitle: {
      text: "",
    },
    credits: {
      enabled: false,
    },
    xAxis: {
      categories: [],
    },
    tooltip: {
      enabled: false,
    },
    plotOptions: {
      column: {
        stacking: "normal",
        dataLabels: {
          enabled: true,
          format: "{point.y:.1f}",
        },
      },
    },
    credits: {
      enabled: false,
    },
    series: [{}],
  };
  const totalBench = props.data?.youtube?.dataBench?.total;

  const new_array_eng = [];

  totalBench.forEach((element) => {
    let number_post_eng = element.total_videos
      ? parseFloat(
          element.total_interactions / element.total_videos
        ).toFixed(2)
      : 0;
    new_array_eng.push(+number_post_eng);
  });

  // for (const tt in totalBench) {
  //   let number_post_eng = totalBench[tt].total_videos
  //     ? parseFloat(
  //         totalBench[tt].interactions.total_interactions /
  //           totalBench[tt].total_videos
  //       ).toFixed(2)
  //     : 0;
  //   new_array_eng.push(+number_post_eng);
  // }
  const posts_engagement = {
    name: "Interaction par post",
    data: new_array_eng,
    color: "#22c4ac",
  };

  options2.series.push(posts_engagement);

  totalBench.map((entry, index) => {
    options2.xAxis.categories.push(entry.name);
  });

  ////////graph31/////////
  let options31 = {
    chart: {
      type: "column",
    },
    title: {
      text: "Total interactions",
      align: "left",
      margin: 50,
    },
    subtitle: {
      text: t("Benchmark.interaction_sector_desc"),
      align: "left",
      margin: 10,
    },
    xAxis: {
      categories: [],
    },
    yAxis: {
      min: 0,
      title: {
        text: "",
      },
      stackLabels: {
        enabled: true,
        style: {
          fontWeight: "bold",
          color:
            // theme
            (Highcharts.defaultOptions.title.style &&
              Highcharts.defaultOptions.title.style.color) ||
            "gray",
          textOutline: "none",
        },
      },
    },
    legend: {
      align: "center",
      verticalAlign: "bottom",
      floating: false,
      backgroundColor:
        Highcharts.defaultOptions.legend.backgroundColor || "white",
      shadow: false,
    },
    tooltip: {
      headerFormat: '<span style="font-size:10px">{point.key}</span><table>',
      pointFormat:
        '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' +
        '<td style="padding:0"><b>{point.y:.1f}</b></td></tr>',
      footerFormat: "</table>",
      shared: true,
      useHTML: true,
    },
    plotOptions: {
      column: {
        stacking: "normal",
        dataLabels: {
          enabled: true,
        },
      },
    },
    credits: {
      enabled: false,
    },
    series: [{}],
  };

  const posts_reactions_array = totalBench.map(
    (item) => parseInt(item.interactions.reactions) ?? 0
  );

  const posts_reactions_stacked = {
    name: "Reaction",
    color: "#22c4ac",
    data: posts_reactions_array,
  };

  //const posts_shares_array = myData.map((item) => item.posts_shares ?? 0);
  // const posts_views_array = totalBench.map(
  //   (item) => parseInt(item.interactions.views) ?? 0
  // );
  // const posts_views_stacked = {
  //   name: "Views",
  //   color: "#6941c6",
  //   data: posts_views_array,
  // };

  //const posts_comments_array = myData.map((item) => item.posts_comments ?? 0);
  const posts_comments_array = totalBench.map(
    (item) => parseInt(item.interactions.comments) ?? 0
  );
  const posts_comments_stacked = {
    name: "Comments",
    color: "Orange",
    data: posts_comments_array,
  };

  options31.series.push(posts_reactions_stacked);
  options31.series.push(posts_comments_stacked);
  totalBench.map((entry, index) => {
    options31.xAxis.categories.push(entry.name);
  });

  ////////graph32/////////
  let options32 = {
    chart: {
      type: "column",
    },
    title: {
      text: t("Performance_report.post_type"),
      align: "left",
      margin: 50,
    },
    subtitle: {
      text: t("Benchmark.post_type_sector_desc"),
      align: "left",
      margin: 10,
    },
    xAxis: {
      categories: [],
    },
    yAxis: {
      min: 0,
      title: {
        text: "",
      },
      stackLabels: {
        enabled: true,
        style: {
          fontWeight: "bold",
          color:
            // theme
            (Highcharts.defaultOptions.title.style &&
              Highcharts.defaultOptions.title.style.color) ||
            "gray",
          textOutline: "none",
        },
      },
    },
    legend: {
      align: "center",
      verticalAlign: "bottom",
      floating: false,
      backgroundColor:
        Highcharts.defaultOptions.legend.backgroundColor || "white",
      shadow: false,
    },
    tooltip: {
      headerFormat: '<span style="font-size:10px">{point.key}</span><table>',
      pointFormat:
        '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' +
        '<td style="padding:0"><b>{point.y:.1f}</b></td></tr>',
      footerFormat: "</table>",
      shared: true,
      useHTML: true,
    },
    plotOptions: {
      column: {
        stacking: "normal",
        dataLabels: {
          enabled: true,
        },
      },
    },
    credits: {
      enabled: false,
    },
    series: [{}],
  };

  const videoListSector = totalBench.map(
    (item) => parseInt(item.posts_videos) ?? 0
  );
  const shortListSector = totalBench.map(
    (item) => parseInt(item.posts_short) ?? 0
  );
  const liveListSector = totalBench.map(
    (item) => parseInt(item.posts_live) ?? 0
  );

  const videoArray = {
    name: "Videos",
    //  color: "orange",
    data: videoListSector,
  };

  const shortArray = {
    name: "Shorts",
    // color: "green",
    data: shortListSector,
  };

  const liveArray = {
    name: "Live",
    // color: "violet",
    data: liveListSector,
  };

  options32.series.push(videoArray);
  options32.series.push(shortArray);
  options32.series.push(liveArray);
  totalBench.map((entry) => {
    options32.xAxis.categories.push(entry.name);
  });

  function remove_empty_value(arr) {
    var index;
    arr.some(function (obj, i) {
      return Object.keys(obj).length === 0 && obj.constructor === Object
        ? ((index = i), true)
        : false;
    });
    arr.shift(index);
    return index;
  }
  remove_empty_value(options2.series);
  remove_empty_value(options31.series);
  remove_empty_value(options32.series);

  //-- exist_data */
  function exist_data(option_data) {
    let exist = false;
    for (let i = 0; i < option_data.length; i++) {
      if (option_data[i].data && option_data[i].data.length > 0) {
        for (let j = 0; j < option_data[i].data.length; j++) {
          if (option_data[i].data[j] !== 0) {
            exist = true;
            break;
          }
        }
      }
    }
    return exist;
  }

  //-- end exist_data */
  let exist_data_op2 = exist_data(options2.series);
  let exist_data_op31 = exist_data(options31.series);
  let exist_data_op32 = exist_data(options32.series);

  const printChart = (event) => {
    event.preventDefault();

    let target = event.target;
    let parent = target.parentElement.parentElement;
    let name = parent.getAttribute("data-value");
    parent.classList.add("capture_style");

    html2canvas(parent, {
      onclone: (document) => {},
    }).then((canvas) => {
      const data = canvas.toDataURL("image/jpg");
      const link = document.createElement("a");

      if (typeof link.download === "string") {
        link.href = data;
        link.download = name + ".jpg";

        parent.classList.remove("capture_style");

        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } else {
        window.open(data);
      }
    });
  };

  // KPI 5 Best Engagement
  const sectorPagesEls = props.data?.dataBench?.best_posts_eng;

  function convert_date(date_to) {
    const date = new Date(date_to);
    const formattedDate = date
      .toLocaleString("en-us", {
        weekday: "short",
        month: "short",
        day: "numeric",
        year: "numeric",
      })
      .replace(/,/g, "");
    return formattedDate;
  }

  const ProductTemplate = () => {
    return (
      <div className="carousel_eng">
        <div className="flex flex-row justify-center mb-4 justify-around flex-wrap">
          {sectorPagesEls.map((sectorPagesEl, index) => (
            <div
              key={index}
              className="bg-white shadow rounded-lg w-72 mt-8 mb-4"
            >
              <div className="">
                <div className="flex mb-2 px-4 pt-4">
                  <img
                    className="w-12 h-12 rounded-full"
                    src={sectorPagesEl?.logo}
                  />
                  <div className="ml-2 mt-0.5">
                    <a
                      href={`https://www.facebook.com/+${sectorPagesEl?.social_id}`}
                      target="_blank"
                    >
                      <span className="block font-medium text-base leading-snug text-black ">
                        {sectorPagesEl?.name_page}
                      </span>
                    </a>
                    <span className="block text-sm text-gray-500 dark:text-gray-400 font-light leading-snug">
                      {convert_date(sectorPagesEl?.creation_time)}
                    </span>
                  </div>
                </div>

                <p className="text-asap-blue  leading-snug md:leading-normal text-xs px-4 line-clamp-3 ">
                  {sectorPagesEl?.message}
                </p>

                <div className="img_post_eng my-4">
                  <img src={sectorPagesEl?.image_post} />
                </div>
              </div>

              <div className="grid grid-cols-3  gap-4 mx-auto mb-4 ml-4">
                <div className="total-fans">
                  <h1 className="text-asap-text text-xs font font-Montserrat font-extrabold">
                    {sectorPagesEl?.angry +
                      sectorPagesEl?.wow +
                      sectorPagesEl?.haha +
                      sectorPagesEl?.likes +
                      sectorPagesEl?.love +
                      sectorPagesEl?.none +
                      sectorPagesEl?.sad +
                      sectorPagesEl?.thankful}
                  </h1>
                  <p className="text-asap-text font-Montserrat text-xs">
                    Reactions
                  </p>
                  <hr className="mt-2" />
                </div>

                <div className="flex items-center gap-2">
                  <div className="total-fans">
                    <h1 className="text-asap-text text-xs font font-Montserrat font-extrabold">
                      {sectorPagesEl?.comments}
                    </h1>
                    <p className="text-asap-text font-Montserrat text-xs">
                      Comments
                    </p>
                    <hr className="mt-2" />
                  </div>
                </div>

                <div className="flex items-center gap-2">
                  <div className="total-fans">
                    <h1 className="text-asap-text text-xs font font-Montserrat font-extrabold">
                      {sectorPagesEl?.shares}
                    </h1>
                    <p className="text-asap-text font-Montserrat text-xs">
                      Shares
                    </p>
                    <hr className="mt-2" />
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    );
  };

  // End KPI 5 Best Engagement

  return (
    <div>
      <div className="highchart_block">
        <div
          data-value="Nombre des posts I Commentaires"
          className="highchart_block1"
        >
          <div className="flex items-center">
            <button
              data-html2canvas-ignore
              onClick={printChart}
              className="ml-auto mr-1.5 w-5 h-5 print_capture"
            ></button>
          </div>
          <HighchartsReact highcharts={Highcharts} options={options32} />
        </div>
      </div>
      <div className="highchart_block">
        <div data-value="Total interactions" className="highchart_block1">
          <div className="flex items-center">
            <button
              data-html2canvas-ignore
              onClick={printChart}
              className="ml-auto mr-1.5 w-5 h-5 print_capture"
            ></button>
          </div>
          <HighchartsReact highcharts={Highcharts} options={options31} />
        </div>
      </div>
      {/* Interactions par post */}
      <div className="highchart_block">
        <div
          data-value="total moyenne des interactions par post"
          className="highchart_block1"
        >
          <div className="flex items-center">
            <button
              data-html2canvas-ignore
              onClick={printChart}
              className="ml-auto mr-1.5 w-5 h-5 print_capture"
            ></button>
          </div>
          <HighchartsReact highcharts={Highcharts} options={options2} />
        </div>
      </div>
      {/* 5 Best Engagement */}
      <ProductTemplate />
      {/* Enf 5 Best Engagement */}
    </div>
  );
};
export default CroissancesChartesYoutube;
